
		<div class="w-100 vh-100 d-flex justify-content-center pt-5">
			<p>
				You haven't the right access to this portal.
				<!--  Please, <a href="{{ url }}">click here</a> to access to the Bea service portal. -->
			</p>
		</div>
	